import ImageOptimizer from '@/components/image-optimizer';
import { useFeaturedStoreReviewList } from '@/services/query/store-review.query';
import { SiteCategory } from '@/services/types/globals.type';
import CommonReviewCarousel from './common-review-carousel';

interface CommonReviewsProps {
  id: string;
}

export default function CommonReviews({ id }: CommonReviewsProps) {
  const { data: featuredStoreReviewList } = useFeaturedStoreReviewList(
    SiteCategory.LICENSE,
  );
  const featuredStoreReviews = featuredStoreReviewList?.data || [];
  return (
    <div id={id} className="w-full">
      {/** 웹 */}
      <div
        className="desktop:flex desktop:pt-[180px] desktop:pb-[160px] hidden flex-col items-center justify-center bg-[#111111] pt-[120px] pb-[80px] text-white"
        style={{
          backgroundImage: `url('/images/recommend-class/common/review_bg1.webp')`,
          backgroundSize: '1420px 420px',
          backgroundPosition: 'center 120px',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="desktop:flex desktop:typo-40 desktop:pb-8 hidden pb-5 text-center font-semibold text-white">
          <span className="font-extrabold">운전 시뮬레이션</span>으로 정말&nbsp;
          <span className="font-extrabold">운전면허취득</span>이 가능하나요?
        </div>
        <div className="desktop:flex typo-24 desktop:typo-28 hidden flex-col items-center justify-center gap-4 text-center font-semibold text-[#ECECEC]">
          <span>3D로 구현된 전국의 모든 운전면허시험장 코스를</span>
          <span>
            반복 주행 연습함으로서 가장 안전하고 빠른 면허 취득을 제안합니다.
          </span>
        </div>
        <ImageOptimizer
          src="/images/recommend-class/common/award_img.png"
          alt="award"
          width={875}
          height={60}
          className="desktop:block mt-14 hidden"
        />

        <div className="desktop:typo-28 typo-18 desktop:mt-20 desktop:mb-10 mt-15 mb-6 text-center font-semibold">
          수강생들의{' '}
          <span className="text-main-yellow font-extrabold">실제 후기</span>를
          확인해보세요
        </div>
        <div className="w-full">
          <CommonReviewCarousel reviews={featuredStoreReviews} />
        </div>
      </div>

      {/** 모바일 */}
      <div
        className="desktop:hidden flex flex-col items-center justify-center bg-[#111111] pt-[120px] pb-[80px] text-white"
        style={{
          backgroundImage: `url('/images/recommend-class/common/review_bg1_mo.webp')`,
          backgroundSize: 'contain',
          backgroundPosition: 'center 60px',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="desktop:hidden typo-28 flex flex-col items-center justify-center gap-2 pb-5 text-center font-semibold text-white">
          <span>
            <span className="font-extrabold">운전 시뮬레이션</span>으로
            정말{' '}
          </span>
          <span>
            <span className="font-extrabold">운전면허취득</span>이 가능하나요?
          </span>
        </div>
        <div className="desktop:hidden typo-18 flex flex-col items-center justify-center gap-2 text-center font-semibold text-[#ECECEC]">
          <span>3D로 구현된 전국의 모든 운전면허시험장</span>
          <span>코스를 반복 주행 연습함으로서</span>
          <span>가장 안전하고 빠른 면허 취득을 제안합니다.</span>
        </div>
        <ImageOptimizer
          src="/images/recommend-class/common/award_img_mo.webp"
          alt="award"
          width={182}
          height={151}
          className="desktop:hidden mt-7"
        />
        <div className="desktop:typo-28 typo-18 desktop:mt-20 desktop:mb-10 mt-15 mb-6 text-center font-semibold">
          수강생들의{' '}
          <span className="text-main-yellow font-extrabold">실제 후기</span>를
          확인해보세요
        </div>
        <div className="w-full">
          <CommonReviewCarousel reviews={featuredStoreReviews} />
        </div>
      </div>
    </div>
  );
}
